import Mensagens from "./MensagemUtils";

class ApiResponse {
  constructor(message, success, data) {
    this.message = message;
    this.success = success;
    this.data = data;
  }

  static fromJson(json) {
    return new ApiResponse(json.message, json.success, json.data);
  }

  static getDados(response) {
    if (response?.data) {
      if (response.data) {
        const apiResponse = ApiResponse.fromJson(response.data);
        return apiResponse;
      }
    } else {
      throw new Error(Mensagens.ERRO.RESPOSTA_NAO_ENCONTRADA_API);
    }
  }
}

export default ApiResponse;
